import Vue from "vue";
import Vuex from "vuex";
import _package from "../../package.json";
import director from "./director";
import headTeacher from "./head-teacher";
import teacher from "./teacher";

Vue.use(Vuex);

const serverURL = _package.server[process.env.NODE_ENV] || "http://192.168.0.200:5000";

const serialize = (obj, prefix) => {
  let str = [];
  let p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      let k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push(v !== null && typeof v === "object" ? serialize(v, k) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
};

export default new Vuex.Store({
  modules: {
    director,
    headTeacher,
    teacher,
  },
  state: {
    path: "/api/v2/telegram",
  },
  actions: {
    FETCH({ dispatch, commit, state }, { url, method, data }) {
      console.log("FETCH", url, method, data);
      const token = sessionStorage.getItem("token");
      const options = {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: token,
        },
        method: "GET",
      };

      if (method != "GET" && method != "VID") {
        options.method = method;
        options.body = JSON.stringify(data);
      }

      if (method == "VID") {
        options.method = "POST";
        options.body = data;

        delete options.headers["Content-Type"];
      }

      return new Promise((resolve, reject) => {
        fetch(`${serverURL}${url}`, options)
          .then(async (response) => {
            if (response.ok) {
              const json = await response.json();
              resolve(json);
            } else {
              console.log(response);
              if (response.status == 401) {
                state.currentPage = "unauth";
                dispatch("LOGOUT");
                reject({ message: { uz: "Sessiya vaqti tugadi, iltimos qaytadan kiring!", ru: "Время сеанса истекло, пожалуйста, войдите снова!" } });
              } else {
                const text = await response.json();

                console.log("JSON NOT OK", text);
                reject(text);
              }
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    ERROR({ state }, { error, errorMessage }) {
      if (state.authenticated) {
        if (error.hasOwnProperty("uz") && error.hasOwnProperty("ru") && state.userLanguage && state.userLanguage.short) {
          Vue.$toast.error(error[state.userLanguage.short]);
        } else {
          Vue.$toast.error(errorMessage);
        }
      }
    },
    auth({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/auth`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    menus({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/menus`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
});
